export const OPERATOR_ROLE = "DISPATCHER";
export const COMPANY_ROLE = "COMPANY";
export const DRIVER_ROLE = "DRIVER";
export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  "741557698692-rhmvrptkasp9qbnrh0qbescno479tj75.apps.googleusercontent.com";

export const DRIVER_ACCOUNT_MESSAGE =
  "Этот аккаунт зарегистрирован как водитель. Войти в операторский кабинет с ним нельзя. Используйте аккаунт оператора.";

export const INCOMPATIBLE_ACCOUNT_MESSAGE =
  "Этот аккаунт не относится к операторскому кабинету. Используйте аккаунт оператора.";

const LOGIN_FLAG_COOKIE = "itruck_logged_in";
const LOGIN_FLAG_MAX_AGE = 60 * 60 * 24 * 30;

const isItruckDomain = () => {
  const hostname = window.location.hostname.toLowerCase();
  return hostname === "itruck.io" || hostname.endsWith(".itruck.io");
};

const getCookieDomain = () => (isItruckDomain() ? "; Domain=itruck.io" : "");
const getSecureFlag = () => (window.location.protocol === "https:" ? "; Secure" : "");

const readCookie = (name) => {
  const prefix = `${encodeURIComponent(name)}=`;
  const cookie = document.cookie
    .split(";")
    .map((item) => item.trim())
    .find((item) => item.startsWith(prefix));

  return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : null;
};

const removeCookie = (name) => {
  const baseCookie = `${encodeURIComponent(name)}=; Path=/; Max-Age=0; SameSite=Lax${getSecureFlag()}`;
  document.cookie = `${baseCookie}${getCookieDomain()}`;

  if (isItruckDomain()) {
    document.cookie = baseCookie;
  }
};

export const hasLoginFlag = () => readCookie(LOGIN_FLAG_COOKIE) === "1";

export const setLoginFlag = () => {
  document.cookie = `${LOGIN_FLAG_COOKIE}=1; Path=/; Max-Age=${LOGIN_FLAG_MAX_AGE}; SameSite=Lax${getCookieDomain()}${getSecureFlag()}`;
};

export const clearAuthTokens = () => {
  window.localStorage.removeItem("access");
  window.localStorage.removeItem("refresh");
  removeCookie(LOGIN_FLAG_COOKIE);
};

export const getOperatorAuthError = (user) => {
  // Drivers are allowed since the fleet cabinet became the web-side «Ищу груз»
  // workspace (ТЗ §8/§10): they see /my-fleet and respond to load requests.
  if (
    user?.role !== OPERATOR_ROLE &&
    user?.role !== COMPANY_ROLE &&
    user?.role !== DRIVER_ROLE
  ) {
    return INCOMPATIBLE_ACCOUNT_MESSAGE;
  }

  return null;
};

export const setAuthErrorMessage = (message) => {
  window.sessionStorage.setItem("auth_error_message", message);
};

export const takeAuthErrorMessage = () => {
  const message = window.sessionStorage.getItem("auth_error_message");

  if (message) {
    window.sessionStorage.removeItem("auth_error_message");
  }

  return message;
};
